module.exports = __webpack_public_path__ + "static/img/pd_top_8.b015651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_top_8.jpg
// module id = TGxk
// module chunks = 52